"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Editor;
var React = _interopRequireWildcard(require("react"));
var _ExampleTheme = _interopRequireDefault(require("./themes/ExampleTheme"));
var _LexicalComposer = require("@lexical/react/LexicalComposer");
var _html = require("@lexical/html");
var _LexicalRichTextPlugin = require("@lexical/react/LexicalRichTextPlugin");
var _LexicalContentEditable = require("@lexical/react/LexicalContentEditable");
var _LexicalHistoryPlugin = require("@lexical/react/LexicalHistoryPlugin");
var _LexicalAutoFocusPlugin = require("@lexical/react/LexicalAutoFocusPlugin");
var _LexicalErrorBoundary = _interopRequireDefault(require("@lexical/react/LexicalErrorBoundary"));
var _ToolbarPlugin = _interopRequireDefault(require("./plugins/ToolbarPlugin"));
var _richText = require("@lexical/rich-text");
var _table = require("@lexical/table");
var _list = require("@lexical/list");
var _code = require("@lexical/code");
var _link = require("@lexical/link");
var _LexicalLinkPlugin = require("@lexical/react/LexicalLinkPlugin");
var _LexicalListPlugin = require("@lexical/react/LexicalListPlugin");
require("./styles.less");
var _ListMaxIndentLevelPlugin = _interopRequireDefault(require("./plugins/ListMaxIndentLevelPlugin"));
var _AutoLinkPlugin = _interopRequireDefault(require("./plugins/AutoLinkPlugin"));
var _OnChangePlugin = require("./plugins/OnChangePlugin");
var _lexical = require("lexical");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getInitialState = function getInitialState(editor, initialValue) {
  editor.update(function () {
    // In the browser you can use the native DOMParser API to parse the HTML string.
    var parser = new DOMParser();
    var dom = parser.parseFromString(initialValue, "text/html");

    // Once you have the DOM instance it's easy to generate LexicalNodes.
    var nodes = (0, _html.$generateNodesFromDOM)(editor, dom);
    var root = (0, _lexical.$getRoot)();
    nodes.forEach(function (node, i) {
      if ((0, _lexical.$isElementNode)(node) || (0, _lexical.$isDecoratorNode)(node)) {
        root.append(node);
      } else {
        var p = (0, _lexical.$createParagraphNode)();
        p.append(node);
        root.append(p);
      }
    });
  });
};
var getEditorConfig = function getEditorConfig(initialValue, editable) {
  return {
    editorState: function editorState(editor) {
      return getInitialState(editor, initialValue);
    },
    namespace: "",
    // The editor theme
    theme: _ExampleTheme["default"],
    // Handling of errors during update
    onError: function onError(error) {
      throw error;
    },
    editable: editable,
    // Any custom nodes go here
    nodes: [_richText.HeadingNode, _list.ListNode, _list.ListItemNode, _richText.QuoteNode, _code.CodeNode, _code.CodeHighlightNode, _table.TableNode, _table.TableCellNode, _table.TableRowNode, _link.AutoLinkNode, _link.LinkNode]
  };
};
function Editor(_ref) {
  var onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    value = _ref.value,
    disabled = _ref.disabled;
  var _onChange = React.useCallback(function (editorState, html) {
    onChange && onChange(html !== null && html !== void 0 ? html : undefined);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(_LexicalComposer.LexicalComposer, {
    initialConfig: getEditorConfig(value !== null && value !== void 0 ? value : "", !disabled)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])("editor-container", disabled && "readonly")
  }, !disabled && /*#__PURE__*/React.createElement(_ToolbarPlugin["default"], null), /*#__PURE__*/React.createElement("div", {
    className: "editor-inner"
  }, /*#__PURE__*/React.createElement(_LexicalRichTextPlugin.RichTextPlugin, {
    contentEditable: /*#__PURE__*/React.createElement(_LexicalContentEditable.ContentEditable, {
      className: "editor-input"
    }),
    placeholder: placeholder ? /*#__PURE__*/React.createElement("div", {
      className: "editor-placeholder"
    }, placeholder !== null && placeholder !== void 0 ? placeholder : "Enter some rich text...") : null,
    ErrorBoundary: _LexicalErrorBoundary["default"]
  }), /*#__PURE__*/React.createElement(_LexicalHistoryPlugin.HistoryPlugin, null), /*#__PURE__*/React.createElement(_LexicalAutoFocusPlugin.AutoFocusPlugin, null), /*#__PURE__*/React.createElement(_LexicalListPlugin.ListPlugin, null), /*#__PURE__*/React.createElement(_LexicalLinkPlugin.LinkPlugin, null), /*#__PURE__*/React.createElement(_OnChangePlugin.OnChangePlugin, {
    onChange: _onChange
  }), /*#__PURE__*/React.createElement(_AutoLinkPlugin["default"], null), /*#__PURE__*/React.createElement(_ListMaxIndentLevelPlugin["default"], {
    maxDepth: 7
  }))));
}